import * as logOutActions from '../../src/store/logout/actions'
import * as appActions from '../store/app/actions'
import {connect} from 'react-redux'
import NavBar from '../components/nav-bar'

export default connect((state) => {
  return {
    isTokenRefreshed: state.refreshToken.isTokenRefreshed,
    languageAccess: state.app.languageAccess,
  }
}, {...logOutActions, ...appActions})(NavBar)



// WEBPACK FOOTER //
// ./src/containers/nav-bar-container.js